import { DashLanguages, firstSupportedDashLanguage } from "dash-common";

type LanguageSource = Pick<Navigator, "language" | "languages">;

const browserNavigator = (): LanguageSource | undefined =>
  typeof navigator === "undefined" ? undefined : navigator;

export const detectBrowserLanguage = (
  source: LanguageSource | undefined = browserNavigator()
): DashLanguages | undefined => {
  if (!source) return undefined;
  return firstSupportedDashLanguage(
    source.languages?.length ? source.languages : [source.language]
  );
};
